import { observer } from 'mobx-react-lite'
import type { TaxJobDetailsViewModel } from '@/features/jobs/details/tax-type/TaxJobDetailsViewModel'
import { MessagesTabLayout } from '@/features/jobs/details/components/MessagesTabLayout'
import { TaxJobConversationContainer } from '@/features/jobs/details/tax-type/components/TaxJobConversationContainer'
import {
  ScheduleCallCalloutContainer,
  ScheduleCallLeadingActionContainer,
} from '@/features/jobs/details/consultation/components/ScheduleCallComposerAction'

interface TaxJobMessagesTabProps {
  taxVm: TaxJobDetailsViewModel
}

/**
 * Messages tab for tax jobs.
 */
export const TaxJobMessagesTab = observer(function TaxJobMessagesTab({
  taxVm,
}: TaxJobMessagesTabProps) {
  return (
    <MessagesTabLayout>
      <TaxJobConversationContainer
        taxVm={taxVm}
        scrollingElement={document.documentElement}
        composerPositioning="fixed"
        composerCallout={
          <ScheduleCallCalloutContainer
            consultationManagerVm={taxVm.consultationManagerVm}
          />
        }
        composerLeadingActions={
          <ScheduleCallLeadingActionContainer
            consultationManagerVm={taxVm.consultationManagerVm}
          />
        }
      />
    </MessagesTabLayout>
  )
})
